import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Contact from '../components/Contact';

const CONTACT = {
  address: 'The Bellagio Office Level 1, Unit L2-22, Mega Kuningan Kav. E4.3, Jakarta 12950, Indonesia',
  phone: '+62 21 3001 9931', // TODO: replace placeholder digits before deploy
  whatsapp: '+628119634567', // TODO: replace placeholder digits before deploy
  whatsappLink: 'https://wa.me/628119634567', // TODO: digits only, no + or spaces
  email: 'admin@redoura.com',
  mapsLink: 'https://maps.app.goo.gl/5eor5qKiN6zrw4Rx9',
  hours: 'Mon – Fri, 9:00 AM – 6:00 PM WIB',
};

const DETAILS = [
  { label: 'Address', value: CONTACT.address },
  { label: 'Phone', value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, '')}` },
  { label: 'WhatsApp', value: CONTACT.whatsapp, href: CONTACT.whatsappLink },
  { label: 'Email', value: CONTACT.email, href: `mailto:${CONTACT.email}` },
  { label: 'Office Hours', value: CONTACT.hours },
];

function ContactUs() {
  return (
    <div className="bg-[#0e1e52]">
      <Navbar />

      {/* Hero — consistent with Services / Our Clients */}
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.06] pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
            backgroundSize: '48px 48px',
          }}
        />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 lg:pt-40">
          <p className="font-mono text-xs tracking-[0.25em] text-[#ce381b] uppercase mb-6">
            Contact Us
          </p>

          <h1
            className="text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl mb-8"
            style={{ fontFamily: "'Fraunces', 'Georgia', serif" }}
          >
            Reach out then we'll help you find the right cover.
          </h1>

          <p className="text-white/60 text-base sm:text-lg leading-relaxed max-w-2xl">
            Whether you have a question about a policy, need a quote, or want
            to talk through your risk, our team is ready to help.
          </p>
        </div>
      </section>

      {/* Details + Map */}
      <section>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 lg:pb-28 grid lg:grid-cols-2 gap-10 lg:gap-16">

          {/* Details list */}
          <div>
            <p className="font-mono text-xs tracking-[0.25em] text-[#ce381b] uppercase mb-8">
              Get In Touch
            </p>

            <ul className="space-y-0 border-t border-white/10">
              {DETAILS.map((item) => (
                <li key={item.label} className="border-b border-white/10 py-5">
                  <p className="font-mono text-[10px] tracking-widest text-white/40 uppercase mb-2">
                    {item.label}
                  </p>
                  {item.href ? (
                    
                     <a href={item.href}
                      target={item.href.startsWith('http') ? '_blank' : undefined}
                      rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="text-white text-base sm:text-lg hover:text-[#ce381b] transition"
                    >
                      {item.value}
                    </a>
                  ) : (
                    <p className="text-white text-base sm:text-lg">{item.value}</p>
                  )}
                </li>
              ))}
            </ul>

            
              < a href={CONTACT.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 mt-8 bg-[#25D366] hover:bg-[#1EBE5A] text-white px-7 py-3.5 text-sm tracking-wide uppercase transition duration-300"
            >
              Chat on WhatsApp
            </a>
          </div>

          {/* Map */}
          <div className="relative bg-[#F6F1E7] p-3 sm:p-4 shadow-2xl -rotate-1">
            <div className="overflow-hidden h-[320px] sm:h-full min-h-[320px]">


              <iframe
                title="Redoura Office Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1983.137442288319!2d106.8228069!3d-6.2274433!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e4ac2fa421%3A0x2de3d495cc84d79d!2sBellagio%20Boutique%20Mall!5e0!3m2!1sen!2sid!4v1790246616155!5m2!1sen!2sid"
                className="w-full h-full grayscale-[15%]"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />



            </div>
            <div className="flex items-center justify-between mt-3 px-1">
              <p className="font-mono text-[10px] tracking-widest text-[#8a7f68] uppercase">
                The Bellagio Office
              </p>
              
                < a href={CONTACT.mapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-[10px] tracking-widest text-[#150F3D] uppercase hover:text-[#ce381b] transition"
              >
                Open in Maps →
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* Consultation form — reused from the home page, pre-expanded here */}
      <Contact defaultOpen />

      <Footer />
    </div>
  );
}

export default ContactUs;